import { api } from './authenticatedApi';

export class ContainerService {
  static async createContainer(repositoryPath: string, socketId: string) {
    return api.post('/containers/create', {
      repositoryPath,
      socketId,
    });
  }

  static async getContainerStatus(containerId: string) {
    return api.get(`/containers/${containerId}/status`);
  }

  static async executeCommand(containerId: string, command: string[], socketId: string) {
    return api.post(`/containers/${containerId}/execute`, {
      command,
      socketId,
    });
  }

  static async listFiles(containerId: string, path?: string) {
    return api.get(`/containers/${containerId}/files`, {
      params: { path },
    });
  }

  static async readFile(containerId: string, filePath: string) {
    return api.get(`/containers/${containerId}/files/${filePath}`);
  }

  static async writeFile(containerId: string, filePath: string, content: string) {
    return api.put(`/containers/${containerId}/files/${filePath}`, {
      content,
    });
  }

  static async stopContainer(containerId: string) {
    return api.delete(`/containers/${containerId}`);
  }

  static async listContainers() {
    return api.get('/containers');
  }
}
